// English texts of the "app" area. Keys start with "app."
export default {
  // main.js
  "app.fallback.document": "document",
  "app.fallback.thisDocument": "this document",
  "app.clipboard.copied": "Copied to clipboard",
  "app.clipboard.copyFailed": "Failed to copy to clipboard",
  "app.clipboard.cut": "Cut to clipboard",
  "app.clipboard.cutFailed": "Failed to cut to clipboard",
  "app.clipboard.destinationChanged": "The destination changed. Please paste again.",
  "app.clipboard.pastedPlainLinks_one": "Pasted. {count} link became a plain item: a map can link another map only once, never itself, and not inside a linked map.",
  "app.clipboard.pastedPlainLinks_other": "Pasted. {count} links became plain items: a map can link another map only once, never itself, and not inside a linked map.",
  "app.clipboard.pasted": "Pasted from clipboard",
  "app.clipboard.pasteFailed": "Failed to paste from clipboard",
  "app.link.plainItemName": "Linked document",
  "app.link.vaultUnavailable": "Vault not available",
  "app.link.notInShared": "Cannot link a document inside a shared document",
  "app.link.notInLinkedMap": "Links can only be added to this map's own items, not inside a linked map",
  "app.link.pickerTitle": "Select document to link",
  "app.link.alreadyLinked": "\"{title}\" is already linked in this document",
  "app.link.sharedTitle": "Link into a shared map",
  "app.link.sharedMessage": "This map is shared. Its members will see the title \"{title}\" and can ask you for access. They won't see its content unless they already have access.",
  "app.link.sharedConfirm": "Link anyway",
  "app.link.linked": "Linked \"{title}\"",
  "app.unlink.title": "Unlink document",
  "app.unlink.message": "Unlink \"{title}\"? It stays in your vault.",
  "app.unlink.confirm": "Unlink",
  "app.unlink.done": "Unlinked \"{title}\"",
  "app.contextMenu.in": "In: {name}",
  "app.doc.createdNotOpened": "Created the document, but couldn't open it. Try opening it from the vault.",
  "app.import.partial": "Imported {imported}/{total} documents.\n\nErrors:\n{errors}",
  "app.setAside.title": "Set aside unreadable updates",
  "app.setAside.message_one": "{count} stored update of this map can't be decrypted with its key. Setting it aside lets sync continue for everyone. Nothing is deleted: the server keeps it, and it still counts in your storage. Export a backup first if you are unsure.",
  "app.setAside.message_other": "{count} stored updates of this map can't be decrypted with its key. Setting them aside lets sync continue for everyone. Nothing is deleted: the server keeps them, and they still count in your storage. Export a backup first if you are unsure.",
  "app.setAside.confirm": "Set aside",
  "app.setAside.done_one": "{count} update set aside. Sync is resuming.",
  "app.setAside.done_other": "{count} updates set aside. Sync is resuming.",
  "app.requestAccess.title": "Request access",
  "app.requestAccess.message": "Ask the owner of \"{title}\" to grant you access? You'll be notified when they respond.",
  "app.requestAccess.sent": "Access requested for \"{title}\".",
  "app.requestAccess.failed": "Could not send request: {error}.",
  "app.requestAccess.tryLater": "try again later",
  "app.share.openFailed": "Could not open the share dialog.",
  "app.offlineQueue.dropped_one": "{count} offline edit dropped due to queue overflow. Reconnect soon to avoid data loss.",
  "app.offlineQueue.dropped_other": "{count} offline edits dropped due to queue overflow. Reconnect soon to avoid data loss.",
  "app.tauri.tooltipServer": "Vault: {vault}\nServer: {server}\nClick to reconfigure.",
  "app.tauri.tooltipLocal": "Vault: {vault}\nLocal-only mode.\nClick to reconfigure.",
  "app.tauri.promptVault": "Vault path (where Orbital stores your .orbital files):",
  "app.tauri.promptServer": "Server URL (leave empty for local-only mode; e.g. https://orbital.example.com):",
  "app.tauri.saveFailed": "Could not save config: {error}",
  "app.header.checking": "Checking...",
  "app.authClose.aria": "Close and return to workspace",
  "app.authClose.title": "Close — return to workspace",
  "app.authClose.failed": "Orbital could not open your local workspace. Please retry. Your server address has been kept.",
  "app.boot.restoringSession": "Restoring session…",
  "app.boot.checkingSession": "Checking session…",

  // interfaces/classic/ui/modals.js
  "app.modal.alert": "Alert",
  "app.revoked.title": "Access revoked",
  "app.revoked.lead": "Access to {name} was revoked.",
  "app.revoked.explainer": "Recover keeps a local copy in your vault with your latest changes.",
  "app.revoked.recover": "Recover now",

  // interfaces/classic/ui/sync-paused.js
  "app.syncPaused.title": "Sync paused",
  "app.syncPaused.titleCount": "Sync paused ({count})",
  "app.syncPaused.message": "Local edits and existing keys are retained. Keep this browser’s data until sync recovers or you have verified a backup.",
  "app.syncPaused.reason.protocol": "The server and Orbital need compatible versions. Update them, then retry sync.",
  "app.syncPaused.reason.key": "The map key could not be verified.",
  "app.syncPaused.reason.conflict": "Conflicting map key histories need to be resolved.",
  "app.syncPaused.reason.unreadable": "Some server updates could not be read.",
  "app.syncPaused.reason.structure": "The vault has conflicting initialization histories. Keep local data for recovery.",
  "app.syncPaused.checking": "Checking sync…",
  "app.syncPaused.preparingBackup": "Preparing backup…",
  "app.syncPaused.stillPaused": "Sync is still paused. You can retry later or export your data.",
  "app.syncPaused.retryFailed": "Sync is still paused. Retry later or export your data.",
  "app.syncPaused.exportFailed": "Export could not complete. Keep your local data and retry.",
  "app.syncPaused.setAsideHint": "Move the updates nobody can read out of sync. Nothing is deleted.",
  "app.syncPaused.settingAside": "Setting the updates aside…",
  "app.syncPaused.setAsideFailed": "The updates could not be set aside. Retry later.",
  "app.syncPaused.vaultIndex": "Vault index",

  // interfaces/classic/ui/shortcut-help.js (keyboard keys stay as they are)
  "app.shortcuts.key.drag": "Drag",
  "app.shortcuts.key.click": "Click",
  "app.shortcuts.or": "or",
  "app.shortcuts.find": "Find & navigate",
  "app.shortcuts.find.search": "Search map or document notes",
  "app.shortcuts.find.next": "Next search result",
  "app.shortcuts.find.previous": "Previous search result",
  "app.shortcuts.find.up": "Go up one level",
  "app.shortcuts.find.structure": "Show or hide Structure",
  "app.shortcuts.daily": "Daily lists & routines",
  "app.shortcuts.daily.notes": "Open or close Notes panel",
  "app.shortcuts.daily.routines": "Open or close Routines panel",
  "app.shortcuts.daily.task": "Add / remove task in daily list",
  "app.shortcuts.daily.task.hint": "Bubbles, Mindmap, Gantt and Kanban; uses the selected document note.",
  "app.shortcuts.daily.routine": "Add node to a routine",
  "app.shortcuts.daily.routine.hint": "Bubbles, Mindmap, Gantt and Kanban.",
  "app.shortcuts.edit": "Edit nodes",
  "app.shortcuts.edit.child": "Add child",
  "app.shortcuts.edit.child.hint": "Bubbles and Mindmap.",
  "app.shortcuts.edit.rename": "Rename title",
  "app.shortcuts.edit.rename.hint": "Bubbles and Mindmap.",
  "app.shortcuts.edit.properties": "Edit properties",
  "app.shortcuts.edit.properties.hint": "Bubbles, Mindmap and Gantt.",
  "app.shortcuts.edit.tags": "Change tags",
  "app.shortcuts.edit.tags.hint": "Hover a node in Bubbles or Mindmap, or a bar or task row in Gantt.",
  "app.shortcuts.edit.fold": "Fold or unfold",
  "app.shortcuts.edit.fold.hint": "Bubbles and Mindmap.",
  "app.shortcuts.edit.delete": "Delete node",
  "app.shortcuts.edit.delete.hint": "Bubbles and Mindmap; excludes the root and focused parent.",
  "app.shortcuts.clipboard": "Clipboard & history",
  "app.shortcuts.clipboard.copy": "Copy node",
  "app.shortcuts.clipboard.cut": "Cut node",
  "app.shortcuts.clipboard.paste": "Paste node",
  "app.shortcuts.move": "Move around the map",
  "app.shortcuts.move.zoom": "Zoom in or out",
  "app.shortcuts.move.zoom.hint": "Mindmap; zooms towards the pointer.",
  "app.shortcuts.move.reparent": "Move a node to another parent",
  "app.shortcuts.move.reparent.hint": "Bubbles and Mindmap.",
  "app.shortcuts.move.cancelDrag": "Cancel a drag",
  "app.shortcuts.move.cancelDrag.hint": "While dragging a node in Bubbles or Mindmap.",
  "app.shortcuts.select": "Select several nodes",
  "app.shortcuts.select.rectangle": "Select with a rectangle",
  "app.shortcuts.select.rectangle.hint": "Mindmap and Bubbles: nodes fully inside; Gantt: bars it touches.",
  "app.shortcuts.select.toggle": "Add or remove a node",
  "app.shortcuts.select.toggle.hint": "Mindmap, Bubbles, Gantt and the task lists.",
  "app.shortcuts.select.range": "Select a range",
  "app.shortcuts.select.range.hint": "Gantt task list and Structure.",
  "app.shortcuts.select.tag": "Tag all selected nodes",
  "app.shortcuts.select.tag.hint": "Each tag shows all, some or none; a click sets or clears it on all.",
  "app.shortcuts.select.move": "Move all selected nodes",
  "app.shortcuts.select.move.hint": "Drag one of them: Ctrl+drag in Mindmap and Bubbles, the grip in the lists.",
  "app.shortcuts.select.leave": "Leave the selection",
  "app.shortcuts.select.leave.hint": "Or click elsewhere. Other shortcuts are off while nodes are selected.",

  // interfaces/classic/managers/context-menu-manager.js
  "app.menu.openDocument": "Open document",
  "app.menu.relatedNotes": "Search for related notes",
  "app.menu.addDailyTask": "Add as task to daily list",
  "app.menu.addTaskFailed": "Could not add task",
  "app.menu.addChild": "Add Child",
  "app.menu.zoomInto": "Zoom Into",
  "app.menu.linkDocument": "Link document here...",
  "app.menu.unlinkDocument": "Unlink document",
  "app.menu.exportBranch": "Export Branch",
  "app.menu.branchExported": "Branch exported",
  "app.menu.exportFailed": "Export failed: {error}",
  "app.menu.importBranch": "Import Branch Here",
  "app.menu.notBranchExport": "Choose a branch export. Use map import for complete documents.",
  "app.menu.destinationChangedRetry": "The destination changed. Retry the import.",
  "app.menu.destinationChangedZip": "The destination changed. Keep the ZIP and retry.",
  "app.menu.branchImported": "Branch imported",
  "app.menu.importFailed": "Import failed: {error}",
  "app.menu.deleteConfirm": "Delete \"{name}\"?\n\nThis will also delete all children.",
  "app.menu.nodeDeleted": "Node deleted",

  // interfaces/classic/ui/doc-properties-modal.js
  "app.docProps.title": "Document Properties",
  "app.docProps.info": "Info",
  "app.docProps.storage": "Storage",
  "app.docProps.loadingSize": "Loading size…",
  "app.docProps.docId": "Document ID",
  "app.docProps.sharing": "Sharing",

  // interfaces/classic/ui/tag-popup.js
  "app.tagPopup.titleMany_one": "Tags · {count} node",
  "app.tagPopup.titleMany_other": "Tags · {count} nodes",
  "app.tagPopup.newTag": "New tag...",
  "app.tagPopup.stateAll": "All selected nodes · click to remove from all",
  "app.tagPopup.stateSome": "Some selected nodes · click to add to all",
  "app.tagPopup.stateNone": "No selected node · click to add to all",
  "app.tagPopup.skipped_one": "{count} of the selected nodes was not changed (another map, or read-only).",
  "app.tagPopup.skipped_other": "{count} of the selected nodes were not changed (another map, or read-only).",

  // interfaces/classic/ui/sidebar-tags.js ({category}: a tag category name, e.g. "Progress")
  "app.sidebarTags.highlight": "Highlight",
  "app.sidebarTags.showAll": "Show all {category}",
  "app.sidebarTags.hideAll": "Hide all {category} — then show just the ones you want",
  "app.sidebarTags.highlightAll": "Highlight all {category}",
  "app.sidebarTags.clearHighlights": "Clear {category} highlights",
  "app.sidebarTags.removeHighlight": "Remove highlight",
  "app.sidebarTags.renameHint": "Double-click to rename",
  "app.sidebarTags.showTagged": "Show tagged nodes",
  "app.sidebarTags.hideTagged": "Hide tagged nodes",
  "app.sidebarTags.highlightTagged": "Highlight tagged nodes",
  "app.sidebarTags.deleteTag": "Delete tag",
  "app.sidebarTags.notTagged": "Not tagged",
  "app.sidebarTags.notTaggedHint": "Nodes with none of the {category} tags",
  "app.sidebarTags.showUntagged": "Show nodes with no {category} tag",
  "app.sidebarTags.hideUntagged": "Hide nodes with no {category} tag",
  "app.sidebarTags.highlightUntagged": "Highlight nodes with no {category} tag",
  "app.sidebarTags.deleteTitle": "Delete tag \"{name}\"?",
  "app.sidebarTags.deleteText": "This will remove the tag from all nodes.",
  "app.sidebarTags.newTagName": "Tag {n}",

  // interfaces/classic/ui/multi-select.js
  "app.multiSelect.label": "Selection",
  "app.multiSelect.count_one": "{count} selected",
  "app.multiSelect.count_other": "{count} selected",
  "app.multiSelect.tagAll": "Tag them all",
  "app.multiSelect.leave": "Leave the selection",
  "app.multiSelect.hintMap": "Ctrl+drag one onto a node to move them all",
  "app.multiSelect.hintGantt": "Drag one in the list to move them all",
  "app.multiSelect.moveInside": "Can't move nodes into one of the selected nodes.",
  "app.multiSelect.notMoved_one": "{count} of the selected nodes could not move there (another map, or read-only).",
  "app.multiSelect.notMoved_other": "{count} of the selected nodes could not move there (another map, or read-only).",

  // interfaces/classic/ui/storage-broken-modal.js
  "app.prefsFull": "This device's storage for settings is full: some view settings (current view, zoom) may not be kept.",
  "app.storageBroken.eyebrow": "Saving stopped",
  "app.storageBroken.title": "Orbital blocked editing to prevent data loss",
  "app.storageBroken.intro": "One of the durable save paths is unavailable. New edits are blocked because continuing could create in-memory changes that disappear after a browser crash or reload.",
  "app.storageBroken.reason": "Reason",
  "app.storageBroken.hint": "Try recovery first. If it cannot save a server snapshot, log out and free disk space before editing again.",
  "app.storageBroken.recover": "Try to recover & reload",
  "app.storageBroken.sendingSnapshot": "Sending an emergency snapshot to the server...",
  "app.storageBroken.noAck": "Emergency compaction did not receive a server acknowledgement.",
  "app.storageBroken.snapshotSaved": "Snapshot saved. Saving local changes...",
  "app.storageBroken.localNotSaved": "Local changes could not be saved. Free disk space or restore vault permissions, then retry.",
  "app.storageBroken.recoveryFailed": "Recovery failed: {error}",
  "app.storageBroken.loggingOut": "Logging out...",
  "app.storageBroken.loggedOut": "Logged out. Reloading...",
  "app.storageBroken.localNotSavedRetry": "Local changes could not be saved. Please retry.",
  "app.storageBroken.logoutFailed": "Logout failed: {error}",
  "app.storageBroken.leaveWarning": "Saving is blocked. Reloading now may lose unsaved in-memory edits.",
  // {detail}: technical detail, not translated
  "app.storageBroken.why.unavailable": "Storage became unavailable.",
  "app.storageBroken.why.indexeddbQuota": "IndexedDB quota exceeded, likely disk full.",
  "app.storageBroken.why.indexeddbUnavailable": "IndexedDB is unavailable or refusing writes.",
  "app.storageBroken.why.indexeddbLoadFailed": "IndexedDB failed to load local document data.",
  "app.storageBroken.why.syncStalled": "Local edits were generated while sync stayed unsynced for over 60 seconds.",
  "app.storageBroken.why.compactionFailed": "Server snapshot compaction failed: {detail}",
  "app.storageBroken.why.serverRejected": "Server rejected a durability-critical write: {detail}",
  "app.storageBroken.why.sendFailed": "A local update could not be sent: {detail}",
  "app.storageBroken.why.ackTimeout": "The server did not acknowledge a saved delta in time: {detail}",
  "app.storageBroken.why.ackLost": "The connection closed before confirming a saved delta: {detail}",
  "app.storageBroken.why.vaultAckTimeout": "Vault sync did not acknowledge a saved delta in time: {detail}",
  "app.storageBroken.why.vaultAckLost": "Vault sync closed before confirming a saved delta: {detail}",
  "app.storageBroken.why.vaultRejected": "Vault sync rejected a durability-critical write: {detail}",

  // interfaces/classic/managers/keyboard-manager.js
  "app.node.newName": "New Node",
  "app.keys.nothingToUndo": "Nothing to undo",
  "app.keys.nothingToRedo": "Nothing to redo",
  "app.keys.cutReadOnly": "Cannot cut in read-only mode",
  "app.keys.pasteReadOnly": "Cannot paste in read-only mode",
  "app.keys.viewOnly": "You have view-only access to this shared map",
  "app.keys.mapFull": "This map is full: delete items, or cut branches and paste them into another map.",
  "app.mapSize.badge": "Map full",
  "app.mapSize.fullTitle": "This map is full",
  "app.mapSize.full": "This map has reached the size limit. You can still view it, delete items, or cut branches and paste them into another map. Once it is below the limit, you can edit it again.",
  "app.mapSize.warning": "This map is {percent}% full. Move some branches to other maps before it fills up.",

  // interfaces/classic/managers/modal-manager.js (node properties)
  "app.nodeModal.title": "Node properties",
  "app.nodeModal.add": "Add node",
  "app.nodeModal.moreOptions": "More options",
  "app.nodeModal.fewerOptions": "Fewer options",
  "app.nodeModal.noTags": "No tags defined",
  "app.nodeModal.root": "Root",
  "app.nodeModal.routine": "↻ Repeat / routine…",
  "app.nodeModal.routineHint": "Save these properties and configure a repeat or routine",
  "app.nodeModal.postpone": "Postpone task…",
  "app.nodeModal.changeReturnDate": "Change return date…",
  "app.nodeModal.postponeHint": "Save these properties and choose a return date",
  "app.nodeModal.postponedUntil": "Postponed until {date}",
  "app.nodeModal.notEditable": "This document is no longer editable. Your form has been kept.",
  "app.nodeModal.chooseParent": "Choose an existing parent before adding this node.",
  "app.nodeModal.addFailed": "Could not add this node. Check that the parent is editable.",
  "app.nodeModal.addError": "Could not add this node. Your form has been kept.",
  // Node color palettes
  "app.palette.vibrant": "Vibrant",
  "app.palette.pastel": "Pastel",
  "app.palette.earth": "Earth",
  "app.palette.ocean": "Ocean",
  "app.palette.sunset": "Sunset",
  "app.palette.mono": "Mono",

  // interfaces/classic/managers/offline-mode.js, document-loader.js, sync-orchestrator.js
  "app.starter.firstMap": "My First Map",
  "app.starter.project": "New Project",
  "app.starter.getStarted": "Get Started",
  "app.load.openingMap": "Opening map…",
  "app.load.openingYourMap": "Opening your map…",
  "app.load.unlocking": "Unlocking…",
  "app.load.loadingMap": "Loading map…",
  "app.load.readingLocal": "Reading local copy…",
  "app.load.localLoaded": "Local copy loaded",
  "app.load.fetching": "Fetching from server…",
  "app.load.syncingWithServer": "Syncing with server…",
  "app.load.building": "Building document…",
  "app.load.preparingView": "Preparing view…",
  "app.load.idConflict": "Document ID conflict. Please create a new document and try again.",
  "app.load.serverUnreachable": "Couldn't reach the server. Check your connection and try again.",
  "app.load.showingCached": "Server unreachable — showing cached version. Changes will sync when you're back online.",
  "app.load.contentNotLoaded": "Could not load document content from the server.",
  "app.load.notSyncedBeforeLogout": "Map data could not be loaded from server. The data may not have synced before logout.",
  "app.load.emptyMapName": "Empty Map (data not synced)",
  "app.interface.choose": "Interface",
  "app.interface.classic": "Classic",
  "app.interface.unavailable": "The interface “{name}” is not available here: Classic is shown.",
  "app.interface.failed": "The interface “{name}” could not start ({error}): Classic is shown.",
  // Header save indicator
  "app.status.savedToFile": "Saved to file",
  "app.status.vaultPath": "Vault: {path}",
  "app.status.storageFull": "Storage full",
  "app.status.storageFullHint": "Local edits are retained. Free space in the vault to resume.",
  "app.status.syncPausedHint": "Local edits are retained. Use the Sync paused notice to retry or export.",
  "app.status.syncing": "Syncing",
  "app.status.sendingFiles": "Sending files",
  "app.status.connecting": "Connecting",
  "app.status.reconnecting": "Reconnecting",
  "app.status.syncFailed": "Sync failed",
  "app.connError.title": "Could not connect",
  "app.connError.message": "The server is currently unavailable. Please check your internet connection and try again.",
  "app.corrupted.title": "Document Error",
  "app.corrupted.message": "The document \"{name}\" appears to be corrupted and cannot be opened. Reason: {reason}. Would you like to delete this document from your vault?",
  "app.corrupted.delete": "Delete Document",
  "app.corrupted.goToVault": "Go to Vault",
  "app.corrupted.deleted": "Document deleted",
  "app.corrupted.deleteFailed": "Failed to delete document",
  "app.revoked.theSharedMap": "the shared map",
  "app.revoked.theSharedDocument": "the shared document",
  "app.revoked.opening": "Access to \"{title}\" was revoked. Opening \"{recovered}\".",
  "app.revoked.noRecovery": "Access to \"{title}\" was revoked. No recovery data was available.",
  "app.revoked.wasEditing": "You were editing this document. Sync has been disconnected to prevent lost work.",
  "app.revoked.recoverOpen": "Recover and open",
  "app.revoked.deferred": "Recovery deferred. Recover \"{title}\" from the notifications panel when ready.",
  "app.revoked.recoveredAs": "Recovered as \"{title}\".",
  "app.revoked.recoverFailed": "Unable to recover \"{title}\". No recovery data was available.",

  // interfaces/classic/managers/modal-notes-editor.js
  "app.nodeModal.notesPlaceholder": "Click to add notes...",
  "app.nodeModal.insertTable": "Insert table",

  // interfaces/classic/integrations/calendar.js
  "app.calendar.allDay": "All day",
  "app.calendar.noEvents": "No events",
  "app.calendar.failedToLoad": "Failed to load:",
  "app.calendar.loading": "Loading calendar events...",
  "app.calendar.proxyDetected": "Local proxy server detected",
  "app.calendar.runProxy": "Run calendar_server.py for secure local proxy",
  "app.calendar.connectIntro": "Connect your calendars to see today's and tomorrow's events",
  "app.calendar.addCalendars": "Add Calendars",
  "app.calendar.namePlaceholder": "Calendar name",
  "app.calendar.remove": "Remove calendar",
  "app.calendar.typeIcs": "Private Link (ICS)",
  "app.calendar.typeCaldav": "CalDAV Auth",
  "app.calendar.icsPlaceholder": "webcal://... or https://...",
  "app.calendar.icsHint": "Copy the \"Private link\" or \"Export\" URL from your calendar",
  "app.calendar.username": "Username",
  "app.calendar.usernamePlaceholder": "your-username",
  "app.calendar.appPassword": "App Password",
  "app.calendar.calendarName": "Calendar Name",
  "app.calendar.localProxyActive": "Local Proxy Active",
  "app.calendar.localProxyPrivate": "Secure local proxy server detected. Your calendar data stays private.",
  "app.calendar.useExternal": "Use external proxy instead",
  "app.calendar.externalProxyUrl": "External CORS proxy URL",
  "app.calendar.corsProxy": "CORS Proxy",
  "app.calendar.tip": "Tip:",
  // {command}: python calendar_server.py
  "app.calendar.runCommand": "Run {command} for a secure local proxy.",
  "app.calendar.proxyRequired": "Required to fetch calendars. Use a trusted proxy or run the local server.",
  "app.calendar.defaultName": "My Calendar",
  "app.calendar.numberedName": "Calendar {n}",

  // Server indicator (engine/core/server-status.js) and where the map is stored (interfaces/classic/ui/map-storage.js)
  "app.status.connected": "Connected",
  "app.status.notSyncing": "Not syncing",
  "app.status.notSignedIn": "Not signed in",
  "app.status.serverTrouble": "Server problem",
  "app.status.tooManyConnections": "Too many connections",
  "app.status.serverBusy": "Server busy",
  "app.status.sessionEnded": "Signed out",
  "app.status.hint.signedOut": "Sign in to keep your maps on the server and sync them to your devices.",
  "app.status.hint.offline": "The server can't be reached. Your changes are kept on this device and sent when the connection returns.",
  "app.status.hint.connectedOnline": "Connected to the server. Changes to this map are saved online.",
  "app.status.hint.connectedLocal": "Connected to the server. This map is stored on this device only.",
  "app.status.hint.sending": "Sending changes to the server…",
  "app.status.hint.filesWaiting_one": "{count} file attached while offline is waiting to be sent.",
  "app.status.hint.filesWaiting_other": "{count} files attached while offline are waiting to be sent.",
  "app.status.hint.connecting": "Connecting to the server…",
  "app.status.hint.reconnecting": "The connection was interrupted and is being restored. Your changes are kept on this device.",
  "app.status.hint.problem": "The server can be reached, but changes to this map are not getting through. They are kept on this device.",
  "app.status.hint.serverTrouble": "The server answers but reports a problem. Your changes are kept on this device.",
  "app.status.hint.tooManyConnections": "This account has too many Orbital windows or devices connected. Close Orbital in another window or on another device: this one then reconnects. Your changes are kept on this device.",
  "app.status.hint.serverBusy": "The server is busy for a moment. Your changes are kept on this device and sent again shortly; nothing to do.",
  "app.status.hint.sessionEnded": "Signed out on this device (in another window or on another device, after a password change, or after a long time without use). Your changes here are kept: sign in again to send them.",
  "app.mapStorage.label": "Where this map is stored",
  "app.mapStorage.online": "Online",
  "app.mapStorage.device": "This device",
  "app.mapStorage.onlineHint": "Stored online and synced to your devices. Click for details.",
  "app.mapStorage.deviceHint": "Stored on this device only. Click to move it online.",
  "app.mapStorage.deviceHintSignedOut": "Stored on this device only. Sign in to move it online.",
  "app.mapStorage.deviceHintNoServer": "Stored on this device.",
  "app.mapStorage.signInFirst": "Sign in to move this map online.",
  "app.mapStorage.moveOnlineTitle": "Move this map online?",
  "app.mapStorage.moveOnlineConfirm": "“{title}” will be stored on the server, synced to your other devices, and can then be shared. It will no longer be kept on this device only.",
  "app.mapStorage.movedOnline": "“{title}” is now online.",
  "app.mapStorage.resumeTitle": "Finish moving online?",
  "app.mapStorage.resumeMessage": "Moving “{title}” online did not finish. Continue now? Files already sent are not sent again. Until it finishes, the map stays on this device.",
  "app.mapStorage.resumeSubmit": "Continue moving",
  "app.mapStorage.moveResumes": "The map stays on this device; moving it again continues where it stopped.",
  "app.mapStorage.keptOnDevice": "You’re offline: “{title}” is kept on this device for now. It goes online by itself when the connection is back.",
  "app.mapStorage.wentOnline": "“{title}” was created while offline. It is now online.",
  "app.mapStorage.goesOnlineLater": "It stays on this device and goes online at the next connection.",
  "app.docProps.location": "Stored",
  "app.docProps.location.online": "Online, synced to your devices",
  "app.docProps.location.device": "On this device only",
  "app.docProps.connection": "Connection",
  "app.mapStorage.moving": "Moving “{title}” online",
  "app.mapStorage.moveOnlineFiles_one": "Its {count} attachment moves with it.",
  "app.mapStorage.moveOnlineFiles_other": "Its {count} attachments move with it.",
  "app.mapStorage.sendingFile": "Sending attachment {current} of {total}…",
  "app.mapStorage.sendingMap": "Sending the map…",
  "app.mapStorage.onlineHintMovable": "Stored online and synced to your devices. Click for details, or to move it to this device.",
  "app.mapStorage.moveToDeviceTitle": "Move this map to this device?",
  "app.mapStorage.moveToDeviceConfirm": "“{title}” will be moved to this device. The online copy will be deleted, and your other devices will no longer have the map.",
  "app.mapStorage.moveToDeviceFiles_one": "Its {count} attachment moves with it; its online copy is deleted too.",
  "app.mapStorage.moveToDeviceFiles_other": "Its {count} attachments move with it; their online copies are deleted too.",
  "app.mapStorage.moveToDeviceMembers_one": "It is shared with {count} person, who will lose access but can keep a copy of the map as it is now.",
  "app.mapStorage.moveToDeviceMembers_other": "It is shared with {count} people, who will lose access but can each keep a copy of the map as it is now.",
  "app.mapStorage.moveToDeviceLinks": "Other maps link to it: on your other devices, those links will no longer open it.",
  "app.mapStorage.toDeviceNeedsServer": "Moving a map to this device needs the server. Try again when connected.",
  "app.mapStorage.movingToDevice": "Moving “{title}” to this device",
  "app.mapStorage.copyingFile": "Copying attachment {current} of {total}…",
  "app.mapStorage.savingOnDevice": "Saving the map on this device…",
  "app.mapStorage.checkingCopy": "Checking the copy on this device…",
  "app.mapStorage.removingAccess": "Removing the members' access…",
  "app.mapStorage.removingOnline": "Deleting the online copy…",
  "app.mapStorage.movedToDevice": "“{title}” is now on this device only.",
  "app.mapStorage.moveToDeviceFailed": "Moving to this device failed: {error}",
  "app.mapStorage.moveToDeviceStays": "The map stays online; moving it again continues where it stopped.",
  "app.mapStorage.moveToDeviceFinishesLater": "The copy on this device is complete; the move finishes at the next start.",
  "app.mapStorage.resumeToDeviceTitle": "Finish moving to this device?",
  "app.mapStorage.resumeToDeviceMessage": "Moving “{title}” to this device did not finish. Continue now? Attachments already copied are not downloaded again. Until it finishes, the map stays online.",
  "app.mapStorage.resumeToDeviceCancel": "Cancel the move",
  "app.mapStorage.toDeviceError.notMovable": "only the owner of an online map can move it to this device, in the desktop app",
  "app.mapStorage.toDeviceError.goneOnline": "the online map is no longer on the server",
  "app.mapStorage.toDeviceError.serverStatus": "the server answered {status}",
  "app.mapStorage.toDeviceError.incomplete": "part of the map could not be read ({error})",
  "app.mapStorage.toDeviceError.contentMismatch": "the copy on this device does not hold the whole map",
  "app.mapStorage.toDeviceError.fileMismatch": "an attachment was not copied correctly",
  "app.mapStorage.goneTitle": "No longer online",
  "app.mapStorage.goneMessage_one": "{names} is no longer online: it was moved to another device, or deleted there. Its copy on this device will be removed.",
  "app.mapStorage.goneMessage_other": "{names} are no longer online: they were moved to another device, or deleted there. Their copies on this device will be removed.",
  "app.mapStorage.goneUnsent": "Changes made on this device and never sent exist only in this copy: save a backup file to keep them.",
  "app.mapStorage.goneBackup": "Save a backup file first",
  "app.mapStorage.goneBackupNotSaved": "The backup file was not saved; nothing was removed.",
  "app.mapStorage.goneRemove": "Remove from this device",
  "app.mapStorage.goneRemoved_one": "{names} was removed from this device.",
  "app.mapStorage.goneRemoved_other": "{names} were removed from this device.",
  "app.mapStorage.filesMissingOnline_one": "{count} attachment did not reach the server; the map stays on this device.",
  "app.mapStorage.filesMissingOnline_other": "{count} attachments did not reach the server; the map stays on this device.",
};
